// Central content for Efi's Apartments (migrated from Webflow).
// Images use the original Webflow CDN URLs to preserve the exact photography.

const A = "https://cdn.prod.website-files.com/69a710bf5700ed57fd4fffa2/";
const B = "https://cdn.prod.website-files.com/69d5dc22152f663daa2b0d79/";
// Locally hosted, real property photography (booking-intent ordered).
const C = "/assets/comfort/";
const D = "/assets/onebed/";
const E = "/assets/petra/";

export const site = {
  name: "Efi's Apartments",
  tagline: "A collection of apartments inside an 18th-century stone home",
  bookingUrl: "https://efisapartmentsmilos.reserve-online.net/",
  phone: "+30 215 215 9912",
  phoneHref: "tel:+302152159912",
  whatsapp: "+30 697 998 3660",
  whatsappHref: "https://wa.me/306979983660",
  email: "contact@efismilos.com",
  emailHref: "mailto:contact@efismilos.com",
  address: "Plaka 848 00, Milos, Greece",
  mapsLink: "https://maps.app.goo.gl/4uhdGTvBKPPT2MhT7",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4506.011554753396!2d24.42524666063349!3d36.73770161083026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1498d8cb1c303701%3A0x54c01354aaf37e98!2sEfi's%20Apartments!5e1!3m2!1sen!2sus!4v1781869736648!5m2!1sen!2sus",
  elfsightId: "elfsight-app-86c15464-a98e-490a-a3fa-1f87f3d273fa",
  logo: "/assets/efis-logo-dark.png",
  logoWhite: "/assets/efis-logo-white.png",
  logoColor: "/assets/efis-logo-color.png",
  credit: { label: "Pharos Growth", url: "https://pharosgrowth.com" },
  mhte: {
    number: "ΜΗΤΕ: 1172K122K0660500",
    numberIcon: "/assets/mhte-emblem.png",
    managedPrefix: "Managed by",
    managedName: "Hotel Operation",
    managedUrl: "https://hoteloperation.com",
  },
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "House History", to: "/about" },
  { label: "Gallery", to: "/gallery" },
  { label: "Discover Milos", to: "/discover-milos" },
  { label: "Milos Travel Guides", to: "/guides" },
  { label: "Contact", to: "/contact" },
];

export const home = {
  heroImage: "/assets/efis-hero.jpg",
  heroTitle: "Trypiti's Oldest Walls, Milos' Best View",
  heroSubtitle: "A collection of apartments inside an 18th-century stone home",
  intro:
    "An 18th-century stone house in Trypiti, restored and lived-in, with a terrace view over the Aegean that sets the tone for everything.",
  introImages: [
    A + "69e3b6315ccbc4aefa9c4485_Rectangle%204%20(1).avif",
    A + "69eb4a3c98a5db4bbe24b529_Rectangle%20204%20(1).avif",
  ],
  features: [
    {
      title: "Aegean Views",
      text: "You won't close the shutters much.",
      image: A + "6a1c7546c4c72358e56b56be_place%201.svg",
    },
    {
      title: "A Home, Not a Hotel",
      text: "Every corner carries the history of the family that built it.",
      image: A + "6a1c7d17ce7c60654d6a6bb7_Place%202%20(1).jpg",
    },
    {
      title: "The Milos of Before",
      text: "Not the Milos on the postcards. The one that was here before.",
      image: A + "6a1c754650966f1b31e237b7_place%203.svg",
    },
  ],
  ownerQuote:
    "I came to Milos as a visitor. Trypiti kept me, and this house is my way of sharing why.",
  ownerBg: "/assets/owners-bg.jpg",
  ownerImages: [
    "/assets/sarakiniko-milos.jpg",
    "/assets/klima-sunset-milos.jpg",
    "/assets/kleftiko-milos.jpg",
    "/assets/firopotamos-village-milos.jpg",
    "/assets/sunset-hero-milos.jpg",
    "/assets/plaka-village-milos.jpg",
  ],
  exploreTitle: "The Island Is Yours to Explore",
  exploreText:
    "Plaka, Klima, Sarakiniko, Firopotamos — Milos rewards the curious, and Trypiti puts you right in the middle of it.",
  exploreMap: "/assets/explore-map-milos.png",
  guidesTitle: "The Milos You Wouldn't Find Alone",
  guidesText:
    "Efi's collected experience since 1995: the beaches worth the drive, the tavernas worth the wait, and everything in between.",
};

export const about = {
  heroTitle: "This House Has Been Here a While",
  intro:
    "An 18th-century stone house in Trypiti, restored and lived-in, with a terrace view over the Aegean that sets the tone for everything.",
  values: [
    {
      title: "Authenticity",
      text: "Nothing here was designed to look like Milos. It just is.",
      image: A + "6a1c7d17ce7c60654d6a6bb7_Place%202%20(1).jpg",
    },
    {
      title: "Local Knowledge",
      text: "Efi knows which beach suits which wind, which taverna has no menu, and which paths are worth it.",
      image: A + "6a102afca058e5242345eaed_Rectangle%20172%20(2).png",
    },
    {
      title: "Quiet by Design",
      text: "No pool bar, no organised excursions, no noise. Just the island, at its own pace.",
      image: A + "6a1c81436d4d91ecdbf00ebb_Quiet%20by%20Design%20(1).jpg",
    },
    {
      title: "Built From This Land",
      text: "Stone walls, blue shutters, and a sense of belonging here since 1995.",
      image: A + "6a1c7ea48def5a8ce08c98f7_Contact%20Bg%20(1).jpg",
    },
  ],
  milestone: {
    year: "1800s",
    title: "The House Is Built",
    text:
      "A family builds their home in Trypiti from the volcanic stone of the hillside. The oven, the cistern, the garden, the small shop — every corner serves a purpose. It is a working house, lived in fully.",
    image: A + "69dec88b4c215e9d256412f6_Rectangle%20157.webp",
  },
  ownerQuote:
    "I came to Milos as a visitor. Trypiti kept me, and this house is my way of sharing why.",
  ownerName: "Efi, Owner",
  ownerImages: [
    A + "69e1f9255bd58b90b96be973_Rectangle%20176.webp",
    A + "6a1ab78e0e4017306fc59db0_Rectangle%20181.png",
  ],
};

export const apartments = [
  {
    slug: "petra-split-level-apartment",
    number: "01",
    name: "Petra Split-Level Apartment",
    short:
      "A split-level stone apartment with a private balcony, a separate bedroom loft, a simply equipped kitchenette, and soundproofed walls that keep the village quiet.",
    tagline: "A Loft Above, A Living Space Below",
    long: [
      "Built across two levels with local wood and volcanic stone, it carries the same character as the rest of the property but with a layout that feels entirely its own.",
      "Downstairs, an open-plan living area with a simply equipped kitchenette and a dining table. Upstairs, a queen bed tucked into the loft gallery — the kind of sleeping space that feels genuinely private rather than just partitioned off. The bathroom is modern, the walls are soundproofed, and a private balcony looks out over the quiet cobblestone street below.",
    ],
    guests: "2 Guests",
    size: "30m²",
    beds: "1 Queen Bed (160×200 cm / 63×79 in) + Sofa Bed",
    bedShort: "1 Queen Bed",
    bath: "1 Bath",
    card: E + "petra-03.jpg",
    hero: E + "petra-03.jpg",
    feature: E + "petra-15.jpg",
    gallery: [
      E + "petra-15.jpg",
      E + "petra-11.jpg",
      E + "petra-01.jpg",
      E + "petra-12.jpg",
      E + "petra-03.jpg",
      E + "petra-16.jpg",
      E + "petra-06.jpg",
      E + "petra-13.jpg",
      E + "petra-04.jpg",
      E + "petra-17.jpg",
      E + "petra-14.jpg",
      E + "petra-02.jpg",
    ],
    heritage: {
      intro:
        "Petra is a charming, fully independent private house within the property — faithfully restored to preserve its traditional Cycladic architecture. Natural volcanic stones and unique touchstones throughout evoke a deep sense of ancient history.",
      features: [
        {
          term: "A Living Micrography of Milos",
          greek: "Tavloto · Stromatsáda",
          text: "The layout mirrors a traditional historic Milos home. The upper-level sleeping area — the tavloto — reflects 18th-century life, when the whole family lived and slept together on a single large mattress on the top floor, a custom known as stromatsáda. Below sit the cosy living room, the kitchen area, and the bathroom.",
          image: E + "petra-09.jpg",
        },
        {
          term: "A Veranda in the Shade",
          greek: "Private outdoor space",
          text: "Petra opens onto its own private veranda — made for morning coffee and an evening glass of wine — held in wonderful natural shade until around 11:00 AM–12:00 PM.",
          image: E + "petra-04.jpg",
        },
      ],
    },
  },
  {
    slug: "comfort-studio-with-garden-view",
    number: "02",
    name: "Comfort Studio with Garden View",
    short:
      "A cosy, simply equipped studio opening onto a shared peaceful garden and a shared roof terrace. Simple, comfortable, and exactly what a good base on a Greek island should feel like.",
    tagline: "The Garden Side of the House",
    long: [
      "A well-put-together studio that feels like yours from the moment you arrive. The split-level layout gives it more character than a standard studio, and the shared terrace and garden are a genuinely lovely spot for a slow morning or a quiet evening.",
    ],
    guests: "2 Guests",
    size: "25m²",
    beds: "1 Full Bed (140×200 cm / 55×79 in)",
    bedShort: "1 Full Bed",
    bath: "1 Bath",
    card: C + "comfort-16.jpg",
    hero: C + "comfort-16.jpg",
    feature: C + "comfort-06.jpg",
    gallery: [
      C + "comfort-16.jpg",
      C + "comfort-06.jpg",
      C + "comfort-11.jpg",
      C + "comfort-13.jpg",
      C + "comfort-05.jpg",
      C + "comfort-07.jpg",
      C + "comfort-10.jpg",
      C + "comfort-08.jpg",
      C + "comfort-12.jpg",
      C + "comfort-15.jpg",
      C + "comfort-04.jpg",
      C + "comfort-14.jpg",
      C + "comfort-09.jpg",
      C + "comfort-01.jpg",
      C + "comfort-02.jpg",
      C + "comfort-03.jpg",
    ],
    heritage: {
      intro:
        "Two ground-floor studios, beautifully restored and brought back to life, crowned with traditional ceilings of authentic real wood planks.",
      features: [
        {
          term: "Ceilings of Real Wood",
          greek: "Távles",
          text: "Each studio is finished with traditional ceilings crafted from authentic real wood planks, known as távles.",
          image: C + "comfort-14.jpg",
        },
        {
          term: "A Garden of Volcanic Rock",
          greek: "Shared garden · private nooks",
          text: "Open your door straight into a lush garden paved with ancient volcanic rock — a pergola, lemon trees, roses, and mature trees offering cool shade through the summer. Each studio keeps its own small, private stone seating area.",
        },
        {
          term: "Studio 1 — The Stone Oven",
          greek: "Preserved fournos",
          text: "An authentic, preserved old stone oven sits right inside the bathroom — a piece of everyday history kept exactly where it always stood.",
          image: C + "comfort-11.jpg",
        },
        {
          term: "Studio 1 — Goúrna & Cistern",
          greek: "Goúrna · Dexamení",
          text: "Beside a small window, a traditional goúrna — a stone sink where families once placed ashes from the wood oven to wash clothes. Directly below sits the dexamení, the historic cistern that gathered rainwater for drinking, showering, and washing.",
          image: C + "comfort-03.jpg",
        },
        {
          term: "A 180° Rooftop Terrace",
          greek: "Communal panorama",
          text: "Both studios share a spacious communal rooftop with a breathtaking 180-degree view over the Milos Gulf, Erimomilos, Adamantas, and the entire west of the island.",
        },
      ],
    },
  },
  {
    slug: "1-bedroom-apartments-with-sea-view-terrace",
    number: "03",
    name: "1-Bedroom Apartments with Sea View Terrace",
    short:
      "A separate bedroom, a simply equipped kitchenette, and a terrace looking straight out over the Aegean.",
    tagline: "The Apartment People Come Back For",
    long: [
      "The separate bedroom is cool and calm, the kitchenette has everything you need to eat in when you feel like it, and the private terrace looks straight out over the Aegean.",
      "That terrace is the reason to book this one. Morning coffee, evening wine, the sea changing colour in between — you'll spend more time out there than you planned.",
    ],
    guests: "2 Guests",
    size: "45m²",
    beds: "1 Full Bed (140×200 cm / 55×79 in) + 2 Sofa Beds",
    bedShort: "1 Full Bed",
    bath: "1 Bath",
    card: D + "onebed-09.jpg",
    hero: D + "onebed-09.jpg",
    feature: D + "onebed-07.jpg",
    gallery: [
      D + "onebed-09.jpg",
      D + "onebed-02.jpg",
      D + "onebed-10.jpg",
      D + "onebed-08.jpg",
      D + "onebed-01.jpg",
      D + "onebed-05.jpg",
      D + "onebed-13.jpg",
      D + "onebed-07.jpg",
      D + "onebed-12.jpg",
      D + "onebed-11.jpg",
      D + "onebed-03.jpg",
      D + "onebed-04.jpg",
    ],
    heritage: {
      intro:
        "A stunning apartment built around two extraordinary, preserved historical features that make a stay here genuinely one of a kind.",
      features: [
        {
          term: "A Bed Inside a Grape Press",
          greek: "Patitíri",
          text: "The master bed is built inside a beautifully preserved patitíri — the original stone grape press villagers used centuries ago to crush grapes for wine — now thoughtfully transformed into a unique double bed.",
          image: D + "onebed-10.jpg",
        },
        {
          term: "The Laundry Stone",
          greek: "Left rough on purpose",
          text: "An original, rough stone where ancestors scrubbed clothes using ashes from the old oven — left deliberately rough, exactly as it was when stains were worked out by hand centuries ago.",
          image: D + "onebed-08.jpg",
        },
        {
          term: "A Private Terrace",
          greek: "Naturally shaded",
          text: "A magnificent private terrace with a wooden table and comfortable chairs — the ultimate spot for morning coffee or sunset, naturally shaded until 11:00 AM–12:00 PM.",
          image: D + "onebed-09.jpg",
        },
        {
          term: "A Rare, Exclusive View",
          greek: "West Milos Gulf",
          text: "Rather than a generic view of the open Aegean, the terrace looks over the West Milos Gulf, Traminthia, Panagia Tourliani, Erimomilos, Vani, Klima, and the Catacombs of Milos. Under a full moon the sea turns so calm it resembles a glassy lake. For both the sunset and the full moon, this terrace is the reason to book.",
          image: D + "onebed-02.jpg",
        },
      ],
    },
  },
];

export const heritage = {
  eyebrow: "Living Heritage",
  title: "Restored in 1995.",
  titleAccent: "Untouched by time.",
  intro:
    "Set inside an authentic 18th-century property, our apartments were meticulously restored in 1995 — rebuilt from the ground up to breathe new life into their historic walls. They stand in Trypiti, a settlement the Greek State protects as a Traditional Cycladic Architectural Heritage site (οικισμός). Its architecture cannot be altered: every wall and every stone remains untouched by time, faithful to the authentic Cycladic style.",
  stats: [
    { value: "18th C.", label: "Original property" },
    { value: "1995", label: "Faithfully restored" },
    { value: "οικισμός", label: "State-protected site" },
  ],
  milestones: [
    { year: "18th C.", title: "Built from volcanic stone", icon: "Mountain" },
    { year: "Protected", title: "A state-recognised Cycladic οικισμός", icon: "Landmark" },
    { year: "1995", title: "Restored from the ground up", icon: "Hammer" },
    { year: "Today", title: "Yours to live in — untouched by time", icon: "Home" },
  ],
  pageTitle: "A Home Untouched by Time",
  glance: [
    { icon: "MapPin", title: "Hilltop in Trypiti", text: "A few steps from Plaka, the Catacombs of Milos, and the island's most celebrated sunset." },
    { icon: "Home", title: "A handful of distinct apartments", text: "Each with its own character, layout and outdoor space — no two stays are alike." },
    { icon: "Waves", title: "Panoramic Aegean views", text: "Sweeping vistas over the West Milos Gulf and the open sea, by day and by moonlight." },
    { icon: "Users", title: "A warm, local welcome", text: "Looked after by the family who restored the house and call this village home." },
  ],
  pageIntro:
    "An authentic 18th-century stone house in Trypiti — faithfully restored in 1995 and protected, by law, exactly as it was built.",
  story: [
    {
      title: "An 18th-Century Property",
      text: "Located in an authentic 18th-century property, our apartments were meticulously restored in 1995 — breathing new life into their historic walls while keeping their original character intact.",
    },
    {
      title: "Protected by the State",
      text: "Trypiti is officially recognised by the Greek State as a Traditional Cycladic Heritage settlement. Its architecture cannot be altered — so the property is preserved exactly in its authentic, time-honoured Cycladic style.",
    },
    {
      title: "A Shared Garden & Community",
      text: "All apartments share a beautiful common garden and a communal terrace — fostering a warm, inviting sense of community, beautifully reminiscent of how neighbourhood life thrived in the 18th century.",
    },
    {
      title: "Historic Stonework",
      text: "The authentic stones running throughout the apartments form a historic volcanic stone wall that has been safely preserved here for centuries, and still anchors the house today.",
    },
    {
      title: "A Note on the Kitchens",
      text: "Our kitchens are simply equipped with everything you need to prepare a lovely breakfast and light snacks.",
    },
  ],
  points: [
    {
      icon: "Landmark",
      title: "Protected Cycladic Heritage",
      text: "Trypiti is officially recognised by the Greek State as a Traditional Cycladic Architectural Heritage settlement. The architecture cannot be altered — so the property stands exactly as it was built.",
    },
    {
      icon: "Coffee",
      title: "Made for Slow Mornings",
      text: "Our kitchens are simply equipped — each with everything you need to prepare a lovely breakfast and light snacks.",
    },
    {
      icon: "Trees",
      title: "A Shared Garden & Terrace",
      text: "Every apartment shares a beautiful common garden and a communal terrace — a warm sense of community, just as neighbourhood life thrived here in the 18th century.",
    },
    {
      icon: "Mountain",
      title: "Centuries-Old Stonework",
      text: "The authentic stones throughout form a historic volcanic stone wall, safely retained for centuries.",
    },
  ],
};

export const amenities = [
  { icon: "Snowflake", label: "Air Conditioning" },
  { icon: "Wifi", label: "Free Wi-Fi" },
  { icon: "CookingPot", label: "Equipped Kitchenette" },
  { icon: "Flame", label: "Cooking Hobs" },
  { icon: "TreePalm", label: "Terrace / Balcony" },
  { icon: "ShowerHead", label: "Modern Bathroom" },
  { icon: "EarOff", label: "Soundproofed Walls" },
  { icon: "Utensils", label: "Dining Table" },
  { icon: "Eye", label: "Sea / Garden View" },
  { icon: "Thermometer", label: "Heating" },
  { icon: "BedDouble", label: "Fresh Linen & Towels" },
  { icon: "Coffee", label: "Coffee & Tea" },
];

export const houseRules = [
  {
    icon: "Clock",
    title: "Check-in & Check-out",
    text: "Check-in is from 3:00 PM to 11:00 PM, and check-out is by 11:00 AM. Late check-outs are subject to availability.",
  },
  {
    icon: "CigaretteOff",
    title: "No Smoking Indoors",
    text: "Smoking is not allowed inside the suite. Guests may use designated outdoor areas.",
  },
  {
    icon: "Moon",
    title: "Quiet Hours",
    text: "To ensure a peaceful stay for all guests, quiet hours are observed from 10:00 PM to 8:00 AM.",
  },
  { icon: "PartyPopper", title: "Parties", text: "Parties / events are not allowed." },
  { icon: "PawPrint", title: "Pets", text: "Pets are not allowed." },
];

export const discover = {
  heroTitle: "Discover Milos",
  heroTagline: "A volcanic island that never quite decided to be ordinary.",
  heroImage: "/assets/discover-hero.webp",

  quote:
    "Milos doesn't reveal itself all at once. Give it a few slow days and it quietly becomes the island you compare every other one to.",
  quoteImage:
    "https://images.pexels.com/photos/14604430/pexels-photo-14604430.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",

  mapEyebrow: "The Lay of the Land",
  mapTitle: "One island, a hundred different days",
  mapText:
    "Seventy beaches, ancient catacombs, fishing hamlets with coloured doors, and a coastline that looks different every time the light moves. And our home sits right in the middle of it, in Trypiti.",
  mapImage: A + "69d5aad67b012ab94c8de6ac_map-part.webp",
  mapBgImage:
    "https://images.unsplash.com/photo-1699020685614-57f4cc28306e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400&ixlib=rb-4.1.0",

  ribbon: [
    "72 beautiful beaches",
    "1 volcanic heart",
    "endless Aegean blue",
    "catacombs older than most cathedrals",
    "sunsets worth planning your day around",
  ],

  poiEyebrow: "Around the Property",
  poiTitle: "Worth Leaving the Terrace For",
  poiText:
    "Everything here is within easy reach of the house — most of it a short drive, some of it a walk. These are the places we send our own guests to first.",
  pois: [
    {
      name: "Mandrákia",
      area: "Fishing hamlet · 10 min",
      text: "A tiny harbour of syrmata — boat garages painted in sea-blues and reds. Come for lunch at the water's edge and one of the island's best beaches nearby.",
      image: "https://images.unsplash.com/photo-1700850139282-9e01d348bf65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "Achivadolímni",
      area: "Best beaches · 15 min",
      text: "The island's longest sandy beach — shallow, calm and unhurried. The easy beach day when you just want sand under your feet.",
      image: "/assets/achivadolimni-beach-milos.jpg",
    },
    {
      name: "Erimómilos",
      area: "Sunset islet",
      text: "The little uninhabited islet off the west coast. Watch the sun fall behind it and the whole gulf turns to copper and rose.",
      image: "/assets/erimomilos-milos.jpg",
    },
    {
      name: "Klíma",
      area: "Most photographed village",
      text: "Rainbow boathouses built right at the waterline, glowing at golden hour. The picture you've already seen of Milos — better in person.",
      image: "https://images.unsplash.com/photo-1684246151131-af631e2d85bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "Vani",
      area: "Especially for sunset",
      text: "A remote former manganese mine turned wild, rust-red cove. One of the island's most underrated places to watch the day end.",
      image: "/assets/vani-milos.jpg",
    },
    {
      name: "Panagía Tourlianí",
      area: "Klimatovoúni · across Trypiti",
      text: "The hillside church on Klimatovoúni, directly across from Trypiti — a peaceful stop with a wide, quiet view over the gulf.",
      image: "/assets/poi-panagia-tourliani-milos.jpg",
    },
    {
      name: "Ágios Nikólaos, Trypiti",
      area: "Built by the village",
      text: "Trypiti's beloved church, raised by the locals themselves — with the village children carrying stones to help build it.",
      image: "/assets/poi-agios-nikolaos-milos.jpg",
    },
    {
      name: "The Ancient Theatre",
      area: "Roman marble · above Klíma",
      text: "A marble Roman theatre carved into the hillside, still framing the same stretch of sea it did two thousand years ago.",
      image: "/assets/poi-ancient-theatre-milos.jpg",
    },
    {
      name: "Where Aphrodite Was Found",
      area: "Venus de Milo · 1820",
      text: "The very spot where the Venus de Milo was unearthed in 1820 — a short walk from the theatre, marked and quietly moving.",
      image: "https://images.unsplash.com/photo-1685062478366-907bf61feee0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&ixlib=rb-4.1.0",
    },
    {
      name: "The Windmills",
      area: "Anemómiloi · 5 min walk",
      text: "The old whitewashed windmills standing guard over Trypiti — a short stroll, and the best place to greet the evening.",
      image: "/assets/poi-windmills-milos.jpg",
    },
    {
      name: "Square of Trypiti",
      area: "Our village",
      text: "Our own village square: a couple of tavernas, a tree for shade, and the unhurried rhythm of island life on your doorstep.",
      image: "/assets/poi-trypiti-square-milos.jpg",
    },
    {
      name: "The Catacombs",
      area: "Early-Christian · a stone's throw",
      text: "The only early-Christian catacombs in Greece — candle-lit galleries carved into the rock, among the most remarkable sites in the Aegean.",
      image: "/assets/catacombs-milos.jpg",
    },
  ],

  gettingAroundTitle: "Getting Around the Island",
  gettingAroundText:
    "Milos rewards wandering. From Trypiti you're central — both coasts are close, and almost everything on this list is a short, scenic drive.",
  gettingAround: [
    { h: "Rent a car", p: "The freedom to chase coves and sunsets on your own schedule. We're happy to arrange one for you." },
    { h: "Beaches: 10–25 min", p: "North and south coasts are both within easy reach, so you can follow the calm side when the Meltémi blows." },
    { h: "Boat to Kleftiko", p: "The pirate sea-caves are only reachable by sea — book a half-day cruise from Adamantas." },
  ],
  efiNote:
    "My honest advice: rent a car — it's by far the best way to see Milos. Alternatively, you can rent an ATV or a scooter. And don't rely on the local bus to explore the island; it doesn't reach many of the best corners, and the timing simply isn't dependable. With a car, the whole island opens up to you.",

  efiEyebrow: "Efi's Milos",
  efiTitle: "The things I'd tell a friend",
  efiText:
    "After years of welcoming guests, I started writing down the answers to the questions I'm always asked — where to swim, where to watch the sun go down, which taverna is worth the drive. These guides are exactly what I'd tell a friend arriving on Milos for the first time. Nothing here is sponsored. It's simply the island I love, and the corners of it I hope you'll love too.",
  efiSignature: "— Efi, your host in Trypiti",

  guidesEyebrow: "The Long Reads",
  guidesTitle: "Milos, in Full",
  guidesText: "Settle in. These are the deeper dives — beaches, villages, food, and the spots most people walk right past.",
};

export const galleryImages = [
  { src: "/assets/sarakiniko-milos.jpg", tag: "Milos" },
  { src: "/assets/kleftiko-milos.jpg", tag: "Milos" },
  { src: "/assets/sunset-hero-milos.jpg", tag: "Milos" },
  { src: "/assets/paleochori-milos.jpg", tag: "Milos" },
  { src: "/assets/mandrakia-village-milos.jpg", tag: "Milos" },
  { src: "/assets/sykia-cave-milos.jpg", tag: "Milos" },
  { src: "/assets/firiplaka-milos.jpg", tag: "Milos" },
  { src: "/assets/klima-sunset-milos.jpg", tag: "Milos" },
  { src: "/assets/firopotamos-village-milos.jpg", tag: "Milos" },
  { src: "/assets/polyaigos-milos.jpg", tag: "Milos" },
  { src: "/assets/agia-kyriaki-milos.jpg", tag: "Milos" },
  { src: "/assets/plaka-village-milos.jpg", tag: "Milos" },
  { src: "/assets/sunset-cruise-milos.jpg", tag: "Milos" },
  { src: "/assets/papafragas-milos.jpg", tag: "Milos" },
  { src: "/assets/plathiena-milos.jpg", tag: "Milos" },
  { src: "/assets/ancient-theatre-milos.jpg", tag: "Milos" },
  { src: "/assets/pollonia-village-milos.jpg", tag: "Milos" },
  { src: "/assets/tsigrado-boat-milos.jpg", tag: "Milos" },
  { src: "/assets/kimolos-milos.jpg", tag: "Milos" },
  { src: "/assets/ancient-milos.jpg", tag: "Milos" },
  { src: E + "petra-15.jpg", tag: "Apartments" },
  { src: E + "petra-03.jpg", tag: "Apartments" },
  { src: E + "petra-01.jpg", tag: "Apartments" },
  { src: E + "petra-11.jpg", tag: "Apartments" },
  { src: E + "petra-12.jpg", tag: "Apartments" },
  { src: E + "petra-04.jpg", tag: "Apartments" },
  { src: C + "comfort-16.jpg", tag: "Apartments" },
  { src: C + "comfort-06.jpg", tag: "Apartments" },
  { src: C + "comfort-11.jpg", tag: "Apartments" },
  { src: C + "comfort-05.jpg", tag: "Apartments" },
  { src: C + "comfort-13.jpg", tag: "Apartments" },
  { src: C + "comfort-10.jpg", tag: "Apartments" },
  { src: D + "onebed-09.jpg", tag: "Apartments" },
  { src: D + "onebed-01.jpg", tag: "Apartments" },
  { src: D + "onebed-02.jpg", tag: "Apartments" },
  { src: D + "onebed-08.jpg", tag: "Apartments" },
  { src: D + "onebed-05.jpg", tag: "Apartments" },
  { src: D + "onebed-03.jpg", tag: "Apartments" },
];

export const policy = {
  title: "Privacy Policy",
  intro:
    "Efi's Apartments is a small, family-run boutique stay in Trypiti, Milos. This policy explains the limited personal data we handle when you visit this website or get in touch to arrange a stay — and how we keep it safe. We comply with the EU General Data Protection Regulation (GDPR).",
  sections: [
    {
      h: "How This Website Works",
      p: [
        "This is a simple informational website. There are no user accounts, and you cannot pay or complete a reservation directly here. When you decide to book, you are taken to our external reservation system, which handles your booking and payment details under its own privacy terms.",
      ],
    },
    {
      h: "Information We Collect",
      intro: "We only collect what you choose to share with us:",
      list: [
        "Contact details — your name, email, phone or WhatsApp number, and the content of your message — when you email, call, or message us about a stay.",
        "Stay details — such as your dates and any special requests — when you send them to us so we can prepare for your visit.",
        "Basic, anonymous usage data that may be gathered by the third-party tools embedded on this site (see below).",
      ],
    },
    {
      h: "How We Use Your Information",
      intro: "We use your information only to:",
      list: [
        "Respond to your enquiries and help arrange your stay.",
        "Send you the practical details you need before and during your visit, such as directions.",
        "Meet our legal and accounting obligations.",
      ],
    },
    {
      h: "Third-Party Services",
      intro:
        "A few trusted third-party services are embedded on this website or used to run our business. Each has its own privacy policy:",
      list: [
        "Our external reservation system, which processes bookings and payments.",
        "Google Maps, used to show our location.",
        "Elfsight, used to display verified guest reviews.",
      ],
    },
    {
      h: "Sharing Your Information",
      list: [
        "We never sell or rent your personal data.",
        "We share information only with the service providers above — strictly to operate this website and arrange your stay — or where we are legally required to do so.",
      ],
    },
    {
      h: "Data Retention & Security",
      p: [
        "We keep your information only for as long as needed to answer your enquiry, host your stay, and meet our legal obligations, and we take reasonable measures to protect it from unauthorised access or disclosure.",
      ],
    },
    {
      h: "Your Rights",
      intro: "Under GDPR you have the right to:",
      list: [
        "Access the personal data we hold about you.",
        "Ask us to correct or delete it, subject to any legal obligations.",
        "Object to or restrict how we use it, and withdraw your consent at any time.",
      ],
    },
    {
      h: "Cookies",
      p: [
        "This website does not use cookies for advertising. Some embedded third-party tools (such as Google Maps or the reviews widget) may set their own cookies; you can manage these through your browser settings.",
      ],
    },
    {
      h: "Contact Us",
      p: [
        "For any question about this policy or your personal data, email contact@efismilos.com or call +30 215 215 9912. Efi's Apartments, Plaka 848 00, Milos, Greece.",
      ],
    },
  ],
};

export const bookingPolicy = {
  title: "Booking Policy",
  intro:
    "We offer two rate types when you book your stay at Efi's Apartments. Choose the one that suits you best — the payment and cancellation terms for each are set out clearly below.",
  rates: [
    {
      name: "Non-Refundable Rate",
      badge: "Best price",
      payment: ["Full payment is required at the time of booking."],
      cancellation: [
        "Free cancellation is not available.",
        "If the booking is cancelled, the cancellation fee is 100% of the total cost of the stay.",
        "In the event of a no-show, the no-show fee is the same as a last-minute cancellation.",
      ],
    },
    {
      name: "Standard Rate",
      badge: "More flexible",
      payment: [
        "A deposit equal to one night is required at the time of booking.",
        "The remaining balance is due 7 days before arrival.",
      ],
      cancellation: [
        "Free cancellation is not available.",
        "If the booking is cancelled, the cancellation fee is the cost of one night.",
        "If the booking is cancelled within 7 days of arrival, the cancellation fee is 100% of the total cost of the stay.",
        "In the event of a no-show, the no-show fee is the same as a last-minute cancellation.",
      ],
    },
  ],
};
